import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Survey' },
    { value: 2, label: 'Daily' },
    { value: 3, label: 'Correction' },
  ],
});
